'use client';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { Fab, useScrollTrigger, Zoom } from '@mui/material';

interface BackToTopButtonProps {
  sx?: any;
}

export const BackToTopButton = ({ sx }: BackToTopButtonProps) => {
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 100,
  });

  const handleBackToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Zoom in={trigger}>
      <Fab
        onClick={handleBackToTop}
        size="medium"
        aria-label="back to top"
        sx={{
          position: 'fixed',
          bottom: { xs: 80, md: 24 },
          right: { xs: 16, md: 24 },
          zIndex: 1200,
          bgcolor: 'background.paper',
          color: 'primary.main',
          boxShadow: (theme) =>
            `0 4px 20px ${theme.palette.mode === 'dark' ? 'rgba(0,0,0,0.5)' : 'rgba(0,0,0,0.1)'}`,
          border: '1px solid',
          borderColor: 'divider',
          '&:hover': {
            bgcolor: 'action.hover',
            transform: 'translateY(-4px)',
          },
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          ...sx,
        }}
      >
        <ArrowUpwardIcon />
      </Fab>
    </Zoom>
  );
};
